import { createFileRoute } from '@tanstack/react-router'
import { LaborContractDashboard } from '@/features/labor-contract-dashboard'

export const Route = createFileRoute('/_authenticated/labor-contract-dashboard')({
  component: LaborContractDashboard,
}) 